// extracted by mini-css-extract-plugin
var _1 = "SummaryHistory__bg--ARty2 SummaryGeneral__bg--WtVJe";
var _2 = "SummaryHistory__blueButton--pkwK7 SummaryGeneral__blueButton--uJ4lS";
var _3 = "SummaryHistory__centeredText--DBwyv fontSize__profileText--q79uE TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _4 = "SummaryHistory__content--Ls9PK";
var _5 = "SummaryHistory__contentInner--HqQS9";
var _6 = "SummaryHistory__date--lZimF";
var _7 = "SummaryHistory__heading--d2lWa fontSize__profileHead--IaEKt TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _8 = "SummaryHistory__icon--RBzAc";
var _9 = "SummaryHistory__iconOuter--DXO5y";
var _a = "SummaryHistory__main--Fd_hE";
var _b = "SummaryHistory__navButtons--J2p1S SummaryGeneral__navButtonsBase--fPxWO";
var _c = "SummaryHistory__outer--X9bQB";
var _d = "SummaryHistory__outerLarge--mVfzF SummaryHistory__outer--X9bQB";
var _e = "SummaryHistory__row--giK83 SummaryHistory__text--cS6Kx fontSize__auxBlockTitle--NLvOG TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _f = "SummaryHistory__rowText--xApwh SummaryHistory__row--giK83 SummaryHistory__text--cS6Kx fontSize__auxBlockTitle--NLvOG TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _10 = "SummaryHistory__spacer--qjdQQ";
var _11 = "SummaryHistory__star--rsf_F";
var _12 = "SummaryHistory__stars--hRoP3";
var _13 = "SummaryHistory__starsCol--yZWq_";
var _14 = "SummaryHistory__summary--jywEB";
var _15 = "SummaryHistory__tables--TCkhh";
var _16 = "SummaryHistory__text--cS6Kx fontSize__auxBlockTitle--NLvOG TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _17 = "SummaryHistory__time--QpPT7";
var _18 = "SummaryHistory__xp--djcEk";
export { _1 as "bg", _2 as "blueButton", _3 as "centeredText", _4 as "content", _5 as "contentInner", _6 as "date", _7 as "heading", _8 as "icon", _9 as "iconOuter", _a as "main", _b as "navButtons", _c as "outer", _d as "outerLarge", _e as "row", _f as "rowText", _10 as "spacer", _11 as "star", _12 as "stars", _13 as "starsCol", _14 as "summary", _15 as "tables", _16 as "text", _17 as "time", _18 as "xp" }
